<template>
    <div>
        <filtro-cadu
            v-model="valueData"
            @limparFiltro="limparFiltro()"
            @filtrar="filtraAnexos()"
            @input="value => closeFilter(value)"
        >
            <div slot="body" style="height: 420px">
                <v-row class="mx-2">
                    <v-col cols="auto">
                        <div class="fontColor1--text">
                            FILTRAR ANEXOS
                        </div>
                    </v-col>
                </v-row>
                <ValidationObserver ref="observer">
                    <v-row class="mx-2">
                        <v-col cols="12">
                            <validation-provider name="tipoDocumento" mode="eager" rules="alpha_spaces|max:40" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="listaTipoDocumento.map(el => el.nome)"
                                    :errorMessage="errors[0]"
                                    title="Tipo de documento"
                                    v-model="tipoDocumento"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row class="mx-2">
                        <v-col cols="12">
                            <validation-provider name="abaRelacionada" mode="eager" rules="alpha_spaces|max:40" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="listaAbaRelacionada.map(el => el.nome)"
                                    :errorMessage="errors[0]"
                                    title="Aba Relacionada"
                                    v-model="abaRelacionada"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row class="mx-2">
                        <v-col cols="auto">
                            <div class="fontColor1--text">
                                PERÍODO (mês e ano)
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="5" class="mx-4">
                          <datepicker-cadu
                            :menuOpen="menuOpen"
                            :inputTitle="'Data Inicial'"
                            :inputValue="dataInicial"
                            :showSelectedDate="dataInicialFormatada"
                            :disabled="false"
                            :validateProviderRules="'yearAndMonthValidator'"
                            :maxDate="maxDate"
                            @value="value => dataInicial = value"
                            width="280"
                          ></datepicker-cadu>
                        </v-col>
                        <v-col cols="5" class="mx-2">
                          <datepicker-cadu
                            :menuOpen="menuOpen"
                            :inputTitle="'Data Final'"
                            :inputValue="dataFinal"
                            :showSelectedDate="dataFinalFormatada"
                            :disabled="false"
                            :validateProviderRules="regrasDataFinal"
                            :minDate="minDate"
                            :maxDate="maxDate"
                            @value="value => dataFinal = value"
                            width="280"
                          ></datepicker-cadu>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </div>
        </filtro-cadu>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import TipoDocumento from '@/services/Dominios/TipoDocumento'
import AbaRelacionada from '@/services/Dominios/AbaRelacionada'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      menuOpen: false,
      tipoDocumento: '',
      listaTipoDocumento: [],
      abaRelacionada: '',
      listaAbaRelacionada: [],
      dataInicial: '',
      dataInicialFormatada: '',
      dataFinal: '',
      dataFinalFormatada: ''
    }
  },
  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')

    this.getDominios()
  },
  computed: {
    regrasDataFinal () {
      if (this.dataInicial) {
        return `yearAndMonthValidator|validateDataFinal: ${this.dataInicial} `
      } else {
        return 'yearAndMonthValidator'
      }
    },
    minDate () {
      if (this.dataInicial) {
        return `01/${this.dataInicial}`
      } else {
        return ''
      }
    },
    maxDate () {
      let dateNow = new Date()
      return `${dateNow.getDay()}/${dateNow.getMonth() + 1}/${dateNow.getFullYear()}`
    }
  },
  methods: {
    getDominios () {
      this.getTipoDocumento()
      this.getAbaRelacionada()
    },
    async getTipoDocumento () {
      let tipoDocumento = new TipoDocumento(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseTipoDocumento = await tipoDocumento.getTipoDocumento()
        this.listaTipoDocumento = responseTipoDocumento.data
      } catch (err) {
        this.listaTipoDocumento = []
      }
    },
    getAbaRelacionada () {
      let abaRelacionada = new AbaRelacionada()
      this.listaAbaRelacionada = abaRelacionada.getAbaRelacionada()
    },
    limparFiltro () {
      this.tipoDocumento = ''
      this.abaRelacionada = ''
      this.dataInicial = ''
      this.dataInicialFormatada = ''
      this.dataFinal = ''
      this.dataInicialFormatada = ''
    },
    async filtraAnexos () {
      if (this.validarDatas()) {
        if (await this.$refs.observer.validate()) {
          let filtro = {
            tipoDocumento: (this.listaTipoDocumento.find(item => item.nome === this.tipoDocumento) != null) ? this.listaTipoDocumento.find(item => item.nome === this.tipoDocumento) : '',
            abaRelacionada: (this.listaAbaRelacionada.find(item => item.nome === this.abaRelacionada) != null) ? this.listaAbaRelacionada.find(item => item.nome === this.abaRelacionada) : { codigo: '', nome: '' },
            dataInicial: this.dataInicial,
            dataFinal: this.dataFinal
          }
          this.$emit('filtrar-anexos', filtro)

          this.valueData = false
        }
      }
    },
    validarDatas () {
      if (this.dataInicial && this.dataFinal) {
        var partsInicial = this.dataInicial.split('/')
        var day = 1
        var month = parseInt(partsInicial[0], 10)
        var year = parseInt(partsInicial[1], 10)
        var dataInicial = new Date(year, month - 1, day)

        var partsFinal = this.dataFinal.split('/')
        month = parseInt(partsFinal[0], 10)
        year = parseInt(partsFinal[1], 10)
        var dataFinal = new Date(year, month - 1, day)

        if (dataInicial <= dataFinal) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    closeFilter (value) {
      if (!value) {
        this.$emit('close')
      }
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    }
  }
}
</script>

<style scoped>

</style>
